<template>
  <div class="research-container d-flex flex-column align-items-center position-relative">
    <maintenance-banner
      v-if="loadedFeatureFlags && showMaintenanceBanner"
      translation-key="cmrad.research_maintenance_banner"
      storage-key="MaintenanceBannerClosedByUser_Research"
      :feature-flag-key="getFeatureFlagKey"
      @show-maintenance-banner="setShowMaintenanceBanner($event)"
    />
    <slot name="top"></slot>
    <b-container v-if="hasBreadcrumbSlot || hasHeadingSlot" :class="'research-middle-header-container'">
      <b-container v-if="hasBreadcrumbSlot" class="d-flex justify-content-between align-items-start" fluid>
        <research-breadcrumbs>
          <slot name="breadcrumb"></slot>
        </research-breadcrumbs>
        <div class="py-3">
          <slot name="status"></slot>
        </div>
      </b-container>
      <b-container v-if="hasHeadingSlot" class="heading-section pb-3 mb-3" fluid>
        <slot name="heading"></slot>
      </b-container>
    </b-container>
    <b-container class="flex-fill d-flex flex-column content relative" :class="containerClass" fluid>
      <slot name="content">
        <slot></slot>
      </slot>
    </b-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import flags from '@/config/feature-flags';

  export default {
    name: 'ResearchContainer',

    components: {
      ResearchBreadcrumbs: () => import('@/Atoms/ResearchBreadcrumb/ResearchBreadCrumbs'),
      MaintenanceBanner: () => import('@/Molecules/MaintenanceBanner'),
    },

    props: {
      containerClass: String,
      headingClass: String,
    },

    computed: {
      ...mapGetters(['loadedFeatureFlags']),

      getFeatureFlagKey() {
        return flags.CMRAD_RESEARCH_MAINTENANCE_BANNER;
      },

      hasBreadcrumbSlot() {
        return !!this.$slots['breadcrumb'];
      },
      hasHeadingSlot() {
        return !!this.$slots['heading'];
      },
    },

    methods: {
      setShowMaintenanceBanner(showMaintenanceBanner) {
        this.showMaintenanceBanner = showMaintenanceBanner;
      },
    },

    data() {
      return {
        showMaintenanceBanner: true,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/utilities/px-to-rem';
  .heading-section {
    position: relative;

    &:before {
      content: '';
      width: calc(100% - 30px);
      height: 1px;
      background-color: var(--gray-300);
      position: absolute;
      bottom: 0;
      left: 15px;
    }
  }

  .content {
    height: calc(100% - var(--menu-size));
    padding: 6px 0 0 0;
  }

  .research-middle-header-container {
    margin: 0;
    padding: 0.5rem 0 0;
  }
</style>
